export default "__VITE_ASSET__DcthzAol__"